import { Button, CardContent, Grid, LinearProgress, Typography } from '@material-ui/core';
import { SendIcon } from '../../icons';
import { useSwaggerClient } from '../../hooks/useSwaggerClient';
import FancyCard from '../fancy/FancyCard';
import { useState } from 'react';
import { formatMoney } from '../../utils';
import FillBalanceForm from '../balance/FillBalanceForm';
import BalanceHistory from './BalanceHistory';
import { MODAL_TYPE, useModals } from '../../hooks/useModal';

function UserAccountBalancePage({ guestId, isAgent, isAdmin, guest }) {
    const { showModal } = useModals();
    const [page, setPage] = useState(0);
    const [pageSize] = useState(50000);
    const [fillActive, setFillActive] = useState(false);

    const [
        balancesData,
        balancesLoading,
        _balancesError,
        _balancesChange,
        balanceReload
    ] = useSwaggerClient('balance', 'getBalance', { userId: guestId });

    const [
        paymentsData,
        paymentsLoading,
        _paymentsError,
        _paymentsChange,
        paymentsReload
    ] = useSwaggerClient('users', 'getPaymentsByUserId', { userId: guestId, page, pageSize });

    const handleBalanceChange = () => {
        setPage(0);
        balanceReload();
        paymentsReload();
        setFillActive(false);
    };

    const handleSendPaymentLink = balance => {
        showModal(MODAL_TYPE.SEND_PAYMENT_LINK, {
            guest,
            balance
        });
    };

    return (
        <Grid item xs={12} container alignContent="flex-start" spacing={3}>
            {(paymentsLoading || balancesLoading) && (
                <Grid item xs={12}>
                    <CardContent>
                        <div className="search-loading">
                            <div className="mb-2">Loading Balance Information...</div>
                            <LinearProgress className="search-bar" />
                        </div>
                    </CardContent>
                </Grid>
            )}
            <Grid item xs={12} sm={6}>
                <h2>Balances</h2>
            </Grid>
            <Grid item xs={12}>
                {balancesData?.balances?.map(balance => (
                    <FancyCard key={balance.slug} style={{ marginBottom: '16px' }}>
                        <CardContent>
                            <Grid container spacing={2}>
                                <Grid item xs={6}>
                                    <p>{balance.name || balance.slug}</p>
                                    <h2>
                                        {formatMoney(balance.amount)} <span>{balance.type}</span>
                                    </h2>
                                </Grid>
                                <Grid
                                    container
                                    item
                                    xs={12}
                                    sm={6}
                                    spacing={2}
                                    justifyContent="flex-end"
                                >
                                    {fillActive !== balance.slug && (
                                        <>
                                            {(isAgent || isAdmin) && (
                                                <Grid item>
                                                    <Button
                                                        onClick={() =>
                                                            handleSendPaymentLink(balance)
                                                        }
                                                        variant="outlined"
                                                        color="primary"
                                                        endIcon={<SendIcon />}
                                                    >
                                                        Send Payment Link
                                                    </Button>
                                                </Grid>
                                            )}
                                            <Grid item>
                                                <Button
                                                    onClick={() => setFillActive(balance.slug)}
                                                    variant="contained"
                                                    color="primary"
                                                >
                                                    Fill up Balance
                                                </Button>
                                            </Grid>
                                        </>
                                    )}
                                    {fillActive === balance.slug && (
                                        <Grid item>
                                            <Button
                                                onClick={() => setFillActive(false)}
                                                variant="outlined"
                                                color="secondary"
                                            >
                                                Close
                                            </Button>
                                        </Grid>
                                    )}
                                </Grid>
                                {fillActive === balance.slug && (
                                    <Grid item xs={12}>
                                        <FillBalanceForm
                                            onBalanceChange={handleBalanceChange}
                                            balanceSlug={balance.slug}
                                            amountHint={balance.amount < 0 ? -balance.amount : 0}
                                        />
                                    </Grid>
                                )}
                            </Grid>
                        </CardContent>
                    </FancyCard>
                ))}
            </Grid>
            <Grid item xs={12}>
                <Typography variant="h2" component="h2" gutterBottom>
                    Transaction History
                </Typography>
                {balancesData?.balances?.map(balance => (
                    <BalanceHistory
                        key={balance.slug}
                        payments={paymentsData?.payments}
                        paymentMethods={paymentsData?.paymentMethods}
                        balanceSlug={balance.slug}
                    />
                ))}
            </Grid>
        </Grid>
    );
}

export default UserAccountBalancePage;
